/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'fabric.linkPicker.button.cancel': 'Скасувати',
  'fabric.linkPicker.button.insert': 'Вставити',
  'fabric.linkPicker.button.save': 'Зберегти',
  'fabric.linkPicker.clearLink': 'Очистити',
  'fabric.linkPicker.clearLinkText': 'Видалити текст',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {нічого не знайдено} one {{count,number} результат} few {{count,number} результати} many {{count,number} результатів} other {{count,number} результату}}',
  'fabric.linkPicker.linkAriaLabel': 'Введіть або вставте посилання в поле',
  'fabric.linkPicker.linkHelperTextAriaLabel': 'Допоміжний відображуваний текст посилання',
  'fabric.linkPicker.linkHelperTextLabel': 'Додайте назву або опис цього посилання',
  'fabric.linkPicker.linkInvalid': 'Укажіть дійсну URL-адресу.',
  'fabric.linkPicker.linkLabel': 'Посилання',
  'fabric.linkPicker.linkPlaceholder': 'Вставте посилання',
  'fabric.linkPicker.linkTextAriaLabel': 'Текст посилання для відображення',
  'fabric.linkPicker.linkTextLabel': 'Текст для відображення (необов’язково)',
  'fabric.linkPicker.linkTextPlaceholder': 'Текст для відображення',
  'fabric.linkPicker.listTitle.recentlyViewed': 'Нещодавно переглянуті',
  'fabric.linkPicker.listTitle.results': 'Результати',
  'fabric.linkPicker.search.error.description': 'Якщо помилка виникатиме знову, оновіть сторінку або зверніться до <a>служби підтримки Atlassian</a>.',
  'fabric.linkPicker.search.error.heading': 'Не вдається завантажити дані.',
  'fabric.linkPicker.search.error.retry': 'Оновити',
  'fabric.linkPicker.search.linkAriaLabel': 'Коли ви набиратимете в полі текст, нижче з’явиться список варіантів',
  'fabric.linkPicker.search.linkLabel': 'Пошук або вставка посилання',
  'fabric.linkPicker.search.linkPlaceholder': 'Знайдіть останні посилання або вставте нове',
  'fabric.linkPicker.search.noResults.description': 'Повторіть спробу, увівши інший запит.',
  'fabric.linkPicker.search.noResults.heading': 'За вашим запитом нічого не знайдено.',
  'fabric.linkPicker.status.submitting': 'Надсилання',
  'fabric.linkPicker.time.message.updated': 'Оновлено {time}',
  'fabric.linkPicker.time.message.viewed': 'Переглянуто {time}',
  'fabric.linkPicker.unhandledError.description': 'Спробуйте перезавантажити сторінку.',
  'fabric.linkPicker.unhandledError.heading': 'Сталася помилка'
};